export default __webpack_public_path__ + "static/media/logo_pink_m.15a9c386.png";